import gsap from 'gsap'

import AudioEngine from '@/webgl/audio/AudioEngine'
import gui from '@/webgl/dev/gui'
import { mix } from '@/webgl/math'
import { TimeEntity } from '@/webgl/runner/entities/Time'
import GameWorld from '@/webgl/runner/GameWorld'
import { ISystem } from '@/webgl/runner/interfaces/ISystem'

export default class ScrollSystem implements ISystem {
  paused: boolean = false

  private _factor: number = 0
  private _speed: number = 0
  private _jauge: number = 0

  private toggleTween: gsap.core.Tween

  constructor(readonly world: GameWorld) {
    /// #if _DEBUG
    const fld = gui.folder('ScrollSystem')
    fld.btn('Icr Jauge', () => {
      this.world.state.alterJauge(0.2)
      this._jauge = this.world.state.value.jauge
    })
    fld.btn('Dcr Jauge', () => {
      this.world.state.alterJauge(-0.2)
      this._jauge = this.world.state.value.jauge
    })
    fld.add(this, '_jauge', { readonly: true })
    fld.add(this, '_speed', { readonly: true })
    fld.add(this.world.settings, 'minSpeed', { min: 0, max: 10 })
    fld.add(this.world.settings, 'maxSpeed', { min: 0, max: 10 })
    /// #endif
  }

  start(): void {
    this.world.events.GamePause.on(this.onPause)
    this.world.events.GameResume.on(this.onResume)
  }

  onPause = () => {
    AudioEngine.pause()
    this.world.settings.scrollSpeed = 0
    this.paused = true
  }

  onResume = () => {
    AudioEngine.resume()
    this.paused = false
  }

  dispose(): void {
    this.world.events.GamePause.off(this.onPause)
    this.world.events.GameResume.off(this.onResume)
  }

  stop(duration: number = 1.5): Promise<void> {
    this.toggleTween?.kill()
    return new Promise<void>((resolve) => {
      this.toggleTween = gsap.to(this, {
        _factor: 0,
        duration,
        onComplete: () => resolve(),
      })
    })
  }

  enable(duration: number = 1.5): Promise<void> {
    this.toggleTween?.kill()
    return new Promise<void>((resolve) => {
      this.toggleTween = gsap.to(this, {
        _factor: 1,
        duration,
        onComplete: () => resolve(),
      })
    })
  }

  update(time: TimeEntity): void {
    this._jauge = this.world.state.value.jauge
    this._speed = this.world.settings.scrollSpeed

    if (this.paused) {
      this.world.settings.scrollSpeed = 0
      return
    }

    const min = this.world.settings.minSpeed
    const max = this.world.settings.maxSpeed
    const speed = mix(min, max, this.world.state.value.jauge)

    this.world.settings.scrollSpeed = speed * this._factor
  }
}
